var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 5C15.2129 5 5 15.2129 5 27.75C5 40.2871 15.2129 50.5 27.75 50.5C40.2871 50.5 50.5 40.2871 50.5 27.75C50.5 15.2129 40.2871 5 27.75 5ZM27.75 8.5C38.4004 8.5 47 17.0996 47 27.75C47 38.4004 38.4004 47 27.75 47C17.0996 47 8.5 38.4004 8.5 27.75C8.5 17.0996 17.0996 8.5 27.75 8.5ZM20.75 18.2754L18.2754 20.75L19.5195 21.9805L25.2754 27.75L19.5195 33.5195L18.2754 34.75L20.75 37.2246L21.9805 35.9805L27.75 30.2246L33.5195 35.9805L34.75 37.2246L37.2246 34.75L35.9805 33.5195L30.2246 27.75L35.9805 21.9805L37.2246 20.75L34.75 18.2754L33.5195 19.5195L27.75 25.2754L21.9805 19.5195L20.75 18.2754Z",
    fill: "#CE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.9bcc3cddca87e48d40531f06b450510f.svg";
export { ForwardRef as ReactComponent };